import { Button } from '@app/components/button/button';
import {
  DialogDescription,
  DialogPanel,
  DialogTitle,
} from '@app/routes/organization/components/dialog-ui-elements';
import { selectInvalidSpaceAccessModal } from '@app/routes/organization/selectors';
import { useAppDispatch, useAppSelector } from '@app/store/store';
import { Dialog } from '@headlessui/react';
import { Trans, useTranslation } from '@hopin-team/provider-translation';
import React, { useCallback } from 'react';

export const InvalidSpaceAccessModal = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const modal = useAppSelector(selectInvalidSpaceAccessModal);

  const onClose = useCallback(() => {
    dispatch({ type: '[organization] invalid space access modal close' });
  }, [dispatch]);

  return (
    <Dialog open={modal.isOpen} onClose={onClose}>
      <div className="bg-[#32343980] fixed inset-0 z-[210]" />
      <DialogPanel>
        <DialogTitle className="flex justify-start w-full font-medium px-6 py-5 !mb-0">
          {t('orgSwitcher.invalidSpaceAccess.title')}
        </DialogTitle>
        <DialogDescription className="!text-left px-6 pb-5">
          <p className="text-sm text-gray-600 mb-0">
            <Trans
              i18nKey="orgSwitcher.invalidSpaceAccess.message"
              t={t}
              values={{
                previousSpaceName: modal.previousSpaceName,
                newSpaceName: modal.newSpaceName,
              }}
              components={{
                bold: <strong className="font-semibold" />,
              }}
            />
          </p>
        </DialogDescription>
        <div className="flex justify-end px-6 py-6 border-t border-gray-200">
          <Button
            className="px-4 border-1 !w-fit"
            size="small"
            onClick={onClose}
          >
            {t('orgSwitcher.invalidSpaceAccess.ok')}
          </Button>
        </div>
      </DialogPanel>
    </Dialog>
  );
};
